'use client';

import { createContext, useContext, useReducer, type Dispatch, type ReactNode } from 'react';
import { initialState, type WizardState } from './wizard-state';
import { wizardReducer, type WizardAction } from './wizard-reducer';


type WizardContextValue = {
    state   : WizardState;
    dispatch: Dispatch<WizardAction>;
};


const WizardContext = createContext<WizardContextValue | null>(null);


export const WizardProvider = ({ children }: { children: ReactNode }) => {
    const [ state, dispatch ] = useReducer(wizardReducer, initialState);

    return (
        <WizardContext.Provider value={ { state, dispatch } }>
            { children }
        </WizardContext.Provider>
    );
};


export const useWizard = () => {
    const ctx = useContext(WizardContext);
    if (!ctx) throw new Error('useWizard must be used inside <WizardProvider>');
    return ctx;
};
